import { render, staticRenderFns } from "./ConvoyTripJoiningManagement.vue?vue&type=template&id=2bb4bff2"
import script from "./ConvoyTripJoiningManagement.vue?vue&type=script&lang=js"
export * from "./ConvoyTripJoiningManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports